export default {
    ru: 'РУ',
    fr: 'FR',
    login: 'Войти',
    scholarships: 'Стипендии',
    faq: 'Вопросы-Ответы',
    blog: 'Блог',
    contacts: 'Контакты'
}